import SidebarForm from "components/SidebarForm"
import richText from "utilities/richText"

export default function SidebarFormSection({ blok }) {
  return (
    <section className="sidebar-form-section lg:px-5">
      <div className="max-w-screen-xl mx-auto flex flex-col lg:flex-row lg:items-start lg:gap-16 pt-8 lg:py-16">
        <div className="sidebar-form-section-content prose-h2:text-primary prose-headings:pb-3 px-5 lg:px-0 pb-8 lg:pb-0 w-full">
          {richText(blok.content)}
        </div>
        <SidebarForm form_url={blok?.form_url}>{richText(blok?.sidebar_content)}</SidebarForm>
      </div>
    </section>
  )
}
